import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle, parseNumber,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllPayments = async () => {

        const { fetchAllPayments, fetchInfoProcessLawyer } = FetchData
        
        fetchAllPayments.executeFetch()
        fetchInfoProcessLawyer.executeFetch()

    }

    const handleClickFetchSpecificPayment = async (idtransaction, flagFormOpeningMode) => {

        const { fetchSpecificPayment } = FetchData
        const { setFormOpeningMode } = globalStates
        const { FormScreen } = Forms
        const { setFormState, onResetForm } = FormScreen

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchSpecificPayment.setParamsToSearch({
            idtransaction: idtransaction,
            fecthTransactionInfo: {
                flag: true,
                refSetFormState: setFormState
            }
        })
        fetchSpecificPayment.executeFetch()

        handleClickShowForm(true)
        setFormOpeningMode(flagFormOpeningMode)

    }

    const handleClickPrintPaymentTicket = async (idtransaction) => {

        const { fetchSpecificPayment } = FetchData
        
        fetchSpecificPayment.setParamsToSearch({
            idtransaction: idtransaction,
            printTicketFlag: true
        })
        fetchSpecificPayment.executeFetch()

    }

    const handleChangeTypeTransaction = async (e) => {

        const { FormScreen } = Forms
        const { setFormState, } = FormScreen

        const { name, value } = e.target


        setFormState(prevState => ({
            ...prevState,
            // efectivo
            idcaja: '',
            deposito_observaciones: '',
            // deposito
            boleta_numero: '',
            idbanco: '',
            aprobacion_referencia_ach: '',
            aprobacion_check: '',
            aprobacion_observaciones: '',
            acceptedFiles: [],
            fileRejections: [],
            [ name ]: value
        }))
    }

    const handleChangeAmount = (event) => {
        const { name, value } = event.target

        const { FormScreen } = Forms
        const { formState, setFormState } = FormScreen

        const valueParsed = parseNumber.setNumberMask(value)
        
        setFormState(prevState => ({
            ...prevState,
            [name ]: valueParsed.value,
            [`${name}_mask`]: valueParsed.value_mask
        }))

        if(formState.movimiento_moneda !== '' && formState.movimiento_tipo_cambio !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: value,
                movimiento_moneda: formState.movimiento_moneda,
                movimiento_tipo_cambio: formState.movimiento_tipo_cambio
            })
        }

    }

    const handleChangeTypeCurrency = (event) => {
        const { FormScreen } = Forms
        const { formState, setFormState } = FormScreen

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_monto !== '' && formState.movimiento_tipo_cambio !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: formState.movimiento_monto,
                movimiento_moneda: value,
                movimiento_tipo_cambio: formState.movimiento_tipo_cambio
            })
        }

    }

    const handleChangeExchangeRate = (event) => {
        const { FormScreen } = Forms
        const { formState, setFormState } = FormScreen

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_monto !== '' && formState.movimiento_moneda !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: formState.movimiento_monto,
                movimiento_moneda: formState.movimiento_moneda,
                movimiento_tipo_cambio: value
            })
        }

    }

    const _calculateTotalQuetzalsAndDollars = async ({refSetFormState, movimiento_monto, movimiento_moneda, movimiento_tipo_cambio}) => {
        switch(movimiento_moneda){
            case 'QUETZAL':
                refSetFormState(prevState => ({
                    ...prevState,
                    movimiento_quetzales: parseFloat(movimiento_monto).toFixed(2) || '', // Valor predeterminado si es indefinido
                    movimiento_dolares: parseFloat(movimiento_monto / movimiento_tipo_cambio).toFixed(2) || '', // Valor predeterminado si es indefinido
                }))
            break
            case 'DOLAR':
                refSetFormState(prevState => ({
                    ...prevState,
                    movimiento_quetzales: parseFloat(movimiento_monto * movimiento_tipo_cambio).toFixed(2) || '', // Valor predeterminado si es indefinido
                    movimiento_dolares: parseFloat(movimiento_monto).toFixed(2) || '', // Valor predeterminado si es indefinido
                }))
            break
            default:
                console.log(`No se reconoce la selección: ${movimiento_moneda}`)
            break
        }
    }

    const handleClickDeletePayment = async (idtransaction) => {
    
        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/legal-notarial/delete-lawyer-payment/${idtransaction}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllPayments()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const handleClickReturnToVehicleReception = async (idlawyer) => {
        navigate(`/juridico/procesos`)
    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
        
        // const enlaceTemporal = document.createElement('a');
        // enlaceTemporal.href = openUrl;
        // enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
        // document.body.appendChild(enlaceTemporal);
        // enlaceTemporal.click();
        // document.body.removeChild(enlaceTemporal);

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
      
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
      
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
      
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');

          } catch (error) {
            console.error('Error al descargar la imagen', error);
          }

    }
    
    const onSubmitForm = async (e, idlawyer) => {

        e.preventDefault()

        const { fetchInfoProcessLawyer } = FetchData
        const { dataInfoProcessLawyer } = fetchInfoProcessLawyer
        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        // Determina si se hace un pago en "efectivo" para confirmar que se incluya información de la caja que recibirá el dinero
        if(formState.movimiento_tipo === 'EFECTIVO' && formState.idcaja === ''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará pago en "efectivo" pero no ha especificado la "caja" que recibe el dinero'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.boleta_numero ===''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado el "número de boleta"'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.idbanco ===''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado el "banco"'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.acceptedFiles.length<=0){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado una "foto", o no ha seleccionado una foto valida'
            })
            return;
        }

        if (parseFloat(formState.movimiento_quetzales) > parseFloat(dataInfoProcessLawyer[0].saldo_total)){
            Swal.fire({
                icon: 'error',
                title: 'No se puede procesar',
                text: 'El monto digitado excede el total a pagar'
            })
            return;
        }

        const _data = new FormData();
        _data.append('idlawyer', idlawyer);
        _data.append('idcaja', formState.idcaja);
        _data.append('idbanco', formState.idbanco);
        _data.append('movimiento_usuario', user.username);
        _data.append('movimiento_fecha', formState.movimiento_fecha);
        _data.append('movimiento_tipo', formState.movimiento_tipo);
        _data.append('movimiento_monto', formState.movimiento_monto);
        _data.append('movimiento_moneda', formState.movimiento_moneda);
        _data.append('movimiento_tipo_cambio', formState.movimiento_tipo_cambio);
        _data.append('movimiento_quetzales', formState.movimiento_quetzales);
        _data.append('movimiento_dolares', formState.movimiento_dolares);
        _data.append('movimiento_observaciones', formState.movimiento_observaciones);
        _data.append('boleta_numero', formState.boleta_numero);
        _data.append('user', user.username);

        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`images`, file);
        });

        // console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)
        await marvarApi.post( `/legal-notarial/create-lawyer-payment`, _data )
            .then(({ data }) => {

                alertMessage(data)
                onResetForm()
                handleClickFetchAllPayments()
                handleClickHideForm()

            })
            .catch(error => {
                console.log('API ERROR: ', error)
                onResetForm()
                handleClickFetchAllPayments()
                handleClickHideForm()
            })
    }
    

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllPayments,
        handleClickFetchSpecificPayment,
        handleClickPrintPaymentTicket,
        handleChangeTypeTransaction,
        handleChangeAmount,
        handleChangeTypeCurrency,
        handleChangeExchangeRate,
        handleClickDeletePayment,
        handleClickReturnToVehicleReception,
        handleClickDownloadImage,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}